import { FormlyFieldConfig } from '@ngx-formly/core';

export let FilterFieldsConfig: FormlyFieldConfig[] = [
  {
    key: 'keywords',
    type: 'autocomplete',
    className: 'grid-col-12',
    props: {
      type: 'text',
      hideOptional: true,
      label: 'Keyword',
      configuration: {
        primaryKeyField: 'value',
        primaryTextField: 'text',
        autocompletePlaceHolderText: 'e.g. Company Name',
        isTagModeEnabled: true,
        labelText: 'Keyword',
        id: 'keyword',
      },
    },
  },
  {
    key: 'types',
    props: { label: 'Type of Notification', group: 'accordion' },
    fieldGroup: [
      {
        key: 'typesCheckbox',
        type: 'multicheckbox',
        defaultValue: { 3: false, 6: false, 7: false },
      },
    ],
  },
  {
    key: 'domain',
    props: { label: 'Domain', group: 'accordion' },
    fieldGroup: [
      {
        key: 'domainCheckbox',
        type: 'multicheckbox',
        defaultValue: { 2: false, 9: false, 6: false, 5: false, 7: false },
        props: {
          options: [
            {
              value: '2',
              label: 'Contract Opportunities',
            },
            {
              value: '9',
              label: 'Assistance Listing',
            },
            {
              value: '6,17,18',
              label: 'Entity Information',
            },
            {
              value: '5',
              label: 'Federal Hierarchy',
            },
            {
              value: '7',
              label: 'Wage Determinations',
            },
          ],
        },
      },
    ],
  },
];
